import { Typography } from '@mui/material';
import React from 'react';
import { useAlertUiTranslation } from '../../../../../hooks';
import { ChannelsSubList } from './ChannelsSubList';
import { CollapsableSection } from './CollapsableSection';
export const AlertLongMessage = ({ data }) => {
    const { t } = useAlertUiTranslation();
    if (data.htmlMessage) {
        return (React.createElement(CollapsableSection, { title: t('common.longMessage'), header: React.createElement(ChannelsSubList, { data: data, filterChannels: ['email', 'fax', 'whatsapp', 'inbox'] }) },
            React.createElement(Typography, { component: 'div', variant: 'body2', sx: {
                    p: 2,
                    '&>div>:first-child/* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */': { marginTop: 0 },
                    '&>div>:last-child': { marginBottom: 0 },
                }, dangerouslySetInnerHTML: { __html: data.htmlMessage } })));
    }
    else {
        return null;
    }
};
